module.exports = __webpack_public_path__ + "static/media/invite-illustration.0b5061b6.png";